 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"view-About-vue":"view-About-vue","view-ChargePassword-vue~view-ConvertMain-vue~view-FAQList-vue~view-FindPasswd-vue~view-Login-vue~vie~d62566bd":"view-ChargePassword-vue~view-ConvertMain-vue~view-FAQList-vue~view-FindPasswd-vue~view-Login-vue~vie~d62566bd","view-ChargePassword-vue":"view-ChargePassword-vue","view-ConvertMain-vue~view-SendResult-vue~view-WalletList(backup)-vue~view-WalletList-vue~view-Wallet~572b46a8":"view-ConvertMain-vue~view-SendResult-vue~view-WalletList(backup)-vue~view-WalletList-vue~view-Wallet~572b46a8","view-ConvertMain-vue":"view-ConvertMain-vue","view-SendResult-vue":"view-SendResult-vue","view-SignUp-vue~view-WalletMain-vue":"view-SignUp-vue~view-WalletMain-vue","view-WalletMain-vue":"view-WalletMain-vue","view-WalletList(backup)-vue":"view-WalletList(backup)-vue","view-WalletList-vue":"view-WalletList-vue","view-FAQList-vue":"view-FAQList-vue","view-FindPasswd-vue":"view-FindPasswd-vue","view-Login-vue":"view-Login-vue","view-NewsList-vue":"view-NewsList-vue","view-NoticeList-vue":"view-NoticeList-vue","view-PushList-vue":"view-PushList-vue","view-QRCodePopUp-vue~view-SendMain-vue":"view-QRCodePopUp-vue~view-SendMain-vue","view-SendMain-vue":"view-SendMain-vue","view-ReceiveMain-vue":"view-ReceiveMain-vue","view-SettingCurrency-vue":"view-SettingCurrency-vue","view-SettingLockScreen-vue":"view-SettingLockScreen-vue","view-SettingPush-vue":"view-SettingPush-vue","view-SignUp-vue":"view-SignUp-vue","view-Intro-vue":"view-Intro-vue","view-Password-vue":"view-Password-vue","view-QRCodePopUp-vue":"view-QRCodePopUp-vue","view-TestPage-vue":"view-TestPage-vue"}[chunkId]||chunkId) + "." + {"view-About-vue":"4b18409f","view-ChargePassword-vue~view-ConvertMain-vue~view-FAQList-vue~view-FindPasswd-vue~view-Login-vue~vie~d62566bd":"b9718ac0","view-ChargePassword-vue":"e4db34c7","view-ConvertMain-vue~view-SendResult-vue~view-WalletList(backup)-vue~view-WalletList-vue~view-Wallet~572b46a8":"0a8d9eed","view-ConvertMain-vue":"714a33c5","view-SendResult-vue":"4e5e890c","view-SignUp-vue~view-WalletMain-vue":"966a5ec1","view-WalletMain-vue":"53631a80","view-WalletList(backup)-vue":"28dfddee","view-WalletList-vue":"f5a57706","view-FAQList-vue":"3f827d7b","view-FindPasswd-vue":"d8aecc7e","view-Login-vue":"25c94a99","view-NewsList-vue":"e14b4710","view-NoticeList-vue":"977048e4","view-PushList-vue":"3a58ecc0","view-QRCodePopUp-vue~view-SendMain-vue":"f056d794","view-SendMain-vue":"27993a7c","view-ReceiveMain-vue":"2a2b22c7","view-SettingCurrency-vue":"93260ad9","view-SettingLockScreen-vue":"dbc261a0","view-SettingPush-vue":"570c1fb9","view-SignUp-vue":"d8ebf634","view-Intro-vue":"9401c1ff","view-Password-vue":"410e2a2f","view-QRCodePopUp-vue":"ff437e96","view-TestPage-vue":"60412444"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"view-ChargePassword-vue~view-ConvertMain-vue~view-FAQList-vue~view-FindPasswd-vue~view-Login-vue~vie~d62566bd":1,"view-ChargePassword-vue":1,"view-ConvertMain-vue~view-SendResult-vue~view-WalletList(backup)-vue~view-WalletList-vue~view-Wallet~572b46a8":1,"view-ConvertMain-vue":1,"view-SendResult-vue":1,"view-SignUp-vue~view-WalletMain-vue":1,"view-WalletMain-vue":1,"view-WalletList(backup)-vue":1,"view-WalletList-vue":1,"view-FAQList-vue":1,"view-FindPasswd-vue":1,"view-Login-vue":1,"view-NewsList-vue":1,"view-NoticeList-vue":1,"view-PushList-vue":1,"view-QRCodePopUp-vue~view-SendMain-vue":1,"view-SendMain-vue":1,"view-ReceiveMain-vue":1,"view-SettingCurrency-vue":1,"view-SettingLockScreen-vue":1,"view-SettingPush-vue":1,"view-SignUp-vue":1,"view-Intro-vue":1,"view-Password-vue":1,"view-QRCodePopUp-vue":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"view-About-vue":"view-About-vue","view-ChargePassword-vue~view-ConvertMain-vue~view-FAQList-vue~view-FindPasswd-vue~view-Login-vue~vie~d62566bd":"view-ChargePassword-vue~view-ConvertMain-vue~view-FAQList-vue~view-FindPasswd-vue~view-Login-vue~vie~d62566bd","view-ChargePassword-vue":"view-ChargePassword-vue","view-ConvertMain-vue~view-SendResult-vue~view-WalletList(backup)-vue~view-WalletList-vue~view-Wallet~572b46a8":"view-ConvertMain-vue~view-SendResult-vue~view-WalletList(backup)-vue~view-WalletList-vue~view-Wallet~572b46a8","view-ConvertMain-vue":"view-ConvertMain-vue","view-SendResult-vue":"view-SendResult-vue","view-SignUp-vue~view-WalletMain-vue":"view-SignUp-vue~view-WalletMain-vue","view-WalletMain-vue":"view-WalletMain-vue","view-WalletList(backup)-vue":"view-WalletList(backup)-vue","view-WalletList-vue":"view-WalletList-vue","view-FAQList-vue":"view-FAQList-vue","view-FindPasswd-vue":"view-FindPasswd-vue","view-Login-vue":"view-Login-vue","view-NewsList-vue":"view-NewsList-vue","view-NoticeList-vue":"view-NoticeList-vue","view-PushList-vue":"view-PushList-vue","view-QRCodePopUp-vue~view-SendMain-vue":"view-QRCodePopUp-vue~view-SendMain-vue","view-SendMain-vue":"view-SendMain-vue","view-ReceiveMain-vue":"view-ReceiveMain-vue","view-SettingCurrency-vue":"view-SettingCurrency-vue","view-SettingLockScreen-vue":"view-SettingLockScreen-vue","view-SettingPush-vue":"view-SettingPush-vue","view-SignUp-vue":"view-SignUp-vue","view-Intro-vue":"view-Intro-vue","view-Password-vue":"view-Password-vue","view-QRCodePopUp-vue":"view-QRCodePopUp-vue","view-TestPage-vue":"view-TestPage-vue"}[chunkId]||chunkId) + "." + {"view-About-vue":"31d6cfe0","view-ChargePassword-vue~view-ConvertMain-vue~view-FAQList-vue~view-FindPasswd-vue~view-Login-vue~vie~d62566bd":"d6a3c1de","view-ChargePassword-vue":"f0a1b76e","view-ConvertMain-vue~view-SendResult-vue~view-WalletList(backup)-vue~view-WalletList-vue~view-Wallet~572b46a8":"99ce76c2","view-ConvertMain-vue":"b7d58781","view-SendResult-vue":"8db709be","view-SignUp-vue~view-WalletMain-vue":"b2df7873","view-WalletMain-vue":"82242510","view-WalletList(backup)-vue":"7069206e","view-WalletList-vue":"6023a979","view-FAQList-vue":"58790e86","view-FindPasswd-vue":"e1213c71","view-Login-vue":"55e57ff1","view-NewsList-vue":"db5e22b7","view-NoticeList-vue":"1052e8a4","view-PushList-vue":"877653f4","view-QRCodePopUp-vue~view-SendMain-vue":"e4afc9ba","view-SendMain-vue":"3f5d19ec","view-ReceiveMain-vue":"6de8782c","view-SettingCurrency-vue":"2d7eccc6","view-SettingLockScreen-vue":"40326f11","view-SettingPush-vue":"f23e2a4e","view-SignUp-vue":"a3030f2f","view-Intro-vue":"836ff7b7","view-Password-vue":"e5646816","view-QRCodePopUp-vue":"d6a3c1de","view-TestPage-vue":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
